import { ID } from './StandartId';

export const ICO = {
  Toggle:ID.ICON+"toggle" ,
  Logo:ID.ICON+"logo",
};
